export class ListSearchSetSearchTextAction {
  constructor(public searchText: string) {}
}
